import { extendTheme } from "@chakra-ui/react"

export const theme = extendTheme({
    colors: {
        brand: {
            'black': '#000',
            'darkGrey': '#232529',
            'grey': '#555861',
            'mediumGrey': '#A1A5B2',
            'lightGrey': '#d5d8e0',
            'buttonBg': '#DC7209',
            'white': '#FFFFFF',
            'textLink': '#186DAF',
            'disabledbg': '#EDEEF2'
        }
    }
})